{
  "appName": "VynaEMR",
  "appTagline": "APAC-First Electronic Medical Records",
  "developedByLabel": "Developed by",
  "loading": "Loading...",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "edit": "Edit",
  "create": "Create",
  "search": "Search",
  "filter": "Filter",
  "actions": "Actions",
  "confirm": "Confirm",
  "back": "Back",
  "next": "Next",
  "previous": "Previous",
  "submit": "Submit",
  "reset": "Reset",
  "close": "Close",
  "yes": "Yes",
  "no": "No",
  "ok": "OK",
  "error": "An error occurred",
  "success": "Success",
  "warning": "Warning",
  "info": "Info",
  "validation": {
    "required": "This field is required",
    "invalidEmail": "Invalid email address",
    "invalidPhone": "Invalid phone number",
    "invalidDate": "Invalid date",
    "minLength": "Minimum {{min}} characters required",
    "maxLength": "Maximum {{max}} characters allowed",
    "passwordMismatch": "Passwords do not match"
  },
  "form": {
    "fieldRequired": "{{field}} is required",
    "selectOption": "Please select an option",
    "discardConfirm": "Discard unsaved changes?",
    "unsavedChanges": "You have unsaved changes",
    "mustBeNonNegativeInteger": "{{field}} must be a whole number (0 or more)",
    "mustBeNonNegativeNumber": "{{field}} must be a number (0 or more)"
  },
  "unsavedChanges": {
    "title": "Unsaved Changes",
    "body": "You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.",
    "stay": "Stay",
    "leave": "Leave"
  },
  "messages": {
    "saveSuccess": "Changes saved successfully",
    "saveError": "Failed to save changes",
    "deleteConfirm": "Are you sure you want to delete this item?",
    "deleteSuccess": "Item deleted successfully",
    "deleteError": "Failed to delete item",
    "networkError": "Network error. Please check your connection.",
    "serverError": "Server error. Please try again later.",
    "unauthorized": "You are not authorized to perform this action."
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "This is the VynaEMR demo — do not enter real patient information (PHI)."
  },
  "network": {
    "offline": "You are offline. Clinical data may not be saved."
  },
  "permissionDenied": {
    "title": "Access Denied",
    "body": "You don't have permission to {{action}}.",
    "genericBody": "You don't have permission to view this resource.",
    "requiredPermission": "Required permission: {{name}}",
    "contactAdmin": "Please contact your administrator if you believe this is in error.",
    "requiresPermissionCode": "Requires permission: {{code}}",
    "requiresLabel": "Requires {{label}}",
    "requiresLabelWithRoles": "Requires {{label}} (held by: {{roles}})",
    "insufficient": "Insufficient permissions"
  },
  "skipToContent": "Skip to content",
  "openMenu": "Open menu",
  "topBar": {
    "searchPlaceholder": "Search patients (MRN, name, NRIC/FIN)...",
    "recentPatients": "Recent Patients",
    "searching": "Searching...",
    "noPatientsFound": "No patients found. Press Enter to search.",
    "notifications": "Notifications",
    "selectFacility": "Select facility",
    "allFacilities": "All Facilities",
    "facilityLabel": "Facility {{id}}",
    "activeDepartment": "Working in",
    "selectDepartment": "Select working department",
    "noDepartmentSelected": "Select a department",
    "departmentLabel": "Department {{id}}",
    "departmentSwitchFailed": "Could not switch"
  },
  "theme": {
    "toggle": "Toggle theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System",
    "current": "Theme: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "Operational",
  "footerHealthIssue": "Connection issue",
  "dobLabel": "DOB {{date}}",
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{current}} of {{total}}",
    "showing": "Showing {{from}} to {{to}} of {{total}}",
    "loadMore": "Load more"
  },
  "table": {
    "empty": "No data",
    "loading": "Loading..."
  },
  "cdsAlert": {
    "severity": {
      "info": "Info",
      "warning": "Warning",
      "critical": "Critical"
    },
    "overridden": "Overridden",
    "acknowledged": "Acknowledged",
    "justificationPlaceholder": "Enter justification reason...",
    "submit": "Submit",
    "acknowledge": "Acknowledge",
    "override": "Override",
    "regionAria": "Clinical decision support alerts",
    "acknowledgeFailed": "Couldn't record the acknowledgment — it was not saved. Please try again.",
    "overrideFailed": "Couldn't record the override — it was not saved. Please try again.",
    "addressedCount_one": "{{count}} addressed",
    "addressedCount_other": "{{count}} addressed"
  },
  "components": {
    "printButton": {
      "defaultLabel": "Print"
    },
    "codeSearch": {
      "searchPlaceholder": "Search codes...",
      "clearAriaLabel": "Clear selection",
      "noCodesFound": "No codes found"
    },
    "demographicPicker": {
      "addPlaceholder": "Add…",
      "loading": "Loading…",
      "noneRecorded": "None recorded",
      "removeAriaLabel": "Remove {{value}}",
      "unavailable": "Value list unavailable",
      "unavailableHint": "The value list could not be loaded. Existing values are unchanged and will still be saved.",
      "uncodedBadge": "uncoded",
      "uncodedTitle": "Recorded before coded values existed. It can be removed, but not added back."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "Access Denied",
      "httpStatus": "HTTP 403",
      "body": "You don’t have permission to view this page.",
      "attemptedLabel": "Attempted:",
      "requiredPermissionLabel": "Required permission:",
      "typicallyHeldByLabel": "Typically held by:",
      "signedInAs": "Signed in as",
      "contactAdminHelp": "If you believe this is in error, contact your system administrator or department head to request the needed role.",
      "goBack": "Go back",
      "dashboard": "Dashboard",
      "contact": "Contact"
    },
    "notificationInbox": {
      "title": "Notifications",
      "markAllRead": "Mark All Read",
      "loading": "Loading notifications...",
      "errorState": "Failed to load notifications.",
      "emptyState": "No notifications found.",
      "ariaFilterStatus": "Filter by status",
      "ariaFilterPriority": "Filter by priority",
      "ariaFilterType": "Filter by type",
      "filterStatus": {
        "all": "All",
        "unread": "Unread",
        "read": "Read"
      },
      "filterPriority": {
        "allLabel": "All Priorities",
        "critical": "Critical",
        "high": "High",
        "normal": "Normal",
        "low": "Low"
      },
      "filterType": {
        "allLabel": "All Types"
      },
      "notificationType": {
        "criticalResult": "Critical Result",
        "orderUpdate": "Order Update",
        "appointmentReminder": "Appointment Reminder",
        "systemAlert": "System Alert",
        "cdsAlert": "Clinical Decision Alert",
        "result": "Result",
        "handoffAssigned": "Handoff"
      },
      "toasts": {
        "allMarkedRead": "All notifications marked as read",
        "markAllReadFailed": "Failed to mark all notifications as read",
        "markReadFailed": "Failed to mark notification as read"
      }
    },
    "entityResolver": {
      "invalidId": "That link isn't valid.",
      "notFound": "Not found, or you don't have access to it."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "Live updates unavailable",
    "body": "New results and alerts will not arrive automatically until the connection is restored.",
    "authBody": "Your session has expired. Log in again to restore live updates.",
    "retry": "Retry",
    "login": "Log in"
  }
}
